module.exports = __webpack_public_path__ + "img/product-banner-1.def726dc.png";